import './style.scss'
import { IonSkeletonText } from '@ionic/react'
import clsx from 'clsx'
import { arrowUndo } from 'ionicons/icons'

import Button from '../../../../Button'
import HsvTalentID from '../../HsvTalentID'
import { useTalentCardContext } from '../_Core/Context'
import TalentCardPaper from '../_Core/TalentCardPaper'

interface TalentCardMediumBackProps {
    visible: boolean
    onFlipCardClick: () => void
}

const TalentCardMediumBack: React.FC<TalentCardMediumBackProps> = ({ visible, onFlipCardClick }) => {
    const { certificate } = useTalentCardContext()

    return (
        <TalentCardPaper
            className={clsx('hsv-talentcard-medium-back' , { 'hsv-talentcard-medium-back--visible': visible })}
            isBackground
        >
            <Button
                className='hsv-talentcard-medium-back__switch-btn'
                fill='clear'
                onClick={(e: any) => {
                    e.stopPropagation()
                    onFlipCardClick()
                }}
                icon={arrowUndo}
                size='small'
            />

            <div
                className='hsv-talentcard-medium-back__talentid-wrapper'
            >
                <div
                    className='hsv-talentcard-medium-back__profile-link'
                >
                    <h3
                        className='ion-text-center'
                    >
                        {certificate?.caption ?? (
                            <IonSkeletonText
                                style={{ width: 200 }}
                            />
                        )}
                    </h3>
                </div>

                <HsvTalentID
                    values={certificate?.vote}
                    id='talent-id-detail'
                    interactive
                />
            </div>
        </TalentCardPaper>
    )
}

export default TalentCardMediumBack
